html {
  position: relative;
  overflow-x: clip;
}

body {
  overflow-x: clip;
}

#cestus-landing-root {
  position: relative;
  z-index: 10;
  background: #02040a;
  color: #f8fafc;
  overflow-x: clip;
}

#cestus-landing-root,
#cestus-landing-root * {
  box-sizing: border-box;
}

#cestus-landing-root a {
  text-decoration: none;
}

.landing-scroll-top {
  align-items: center;
  backdrop-filter: blur(14px);
  background:
    linear-gradient(180deg, rgba(15, 23, 42, 0.62), rgba(2, 6, 23, 0.42)),
    rgba(2, 6, 23, 0.32);
  border: 1px solid rgba(96, 165, 250, 0.22);
  border-radius: 999px;
  bottom: max(1.25rem, env(safe-area-inset-bottom));
  box-shadow:
    0 18px 55px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  color: rgba(219, 234, 254, 0.82);
  cursor: pointer;
  display: inline-flex;
  height: 2.75rem;
  justify-content: center;
  position: fixed;
  right: max(1.25rem, env(safe-area-inset-right));
  transition:
    background 180ms ease,
    border-color 180ms ease,
    color 180ms ease,
    transform 180ms ease;
  width: 2.75rem;
  z-index: 60;
}

.landing-scroll-top:hover {
  background:
    linear-gradient(180deg, rgba(30, 64, 175, 0.48), rgba(2, 6, 23, 0.54)),
    rgba(2, 6, 23, 0.48);
  border-color: rgba(96, 165, 250, 0.45);
  color: #eff6ff;
  transform: translateY(-2px);
}

.landing-scroll-top:focus-visible {
  outline: 2px solid rgba(96, 165, 250, 0.9);
  outline-offset: 4px;
}

.landing-scroll-top__icon {
  height: 1.35rem;
  width: 1.35rem;
}

.landing-sign-in {
  background: transparent;
  border: 0;
  color: #f8fafc;
  cursor: pointer;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 0.75rem;
  letter-spacing: 0.34em;
  padding: 0;
  text-transform: uppercase;
  transition: color 180ms ease, text-shadow 180ms ease;
}

.landing-sign-in:hover {
  color: #dbeafe;
  text-shadow: 0 0 24px rgba(59, 130, 246, 0.45);
}

.landing-hero__media {
  justify-self: stretch;
}

.landing-video-frame {
  aspect-ratio: 4 / 5;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.88), rgba(2, 6, 23, 0.55));
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow:
    0 24px 80px rgba(2, 6, 23, 0.8),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  overflow: hidden;
  position: relative;
}

.landing-video {
  display: block;
  height: 100%;
  object-fit: cover;
  opacity: 0.8;
  width: 100%;
}

.landing-video__overlay {
  background:
    linear-gradient(180deg, rgba(2, 6, 23, 0.1) 0%, rgba(2, 6, 23, 0.65) 100%),
    radial-gradient(circle at center, rgba(59, 130, 246, 0.16), transparent 62%);
  inset: 0;
  position: absolute;
}

.landing-bridge {
  border-top: 1px solid rgba(148, 163, 184, 0.12);
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 16rem) minmax(0, 1fr);
  padding: 1.5rem 2rem;
}

.landing-sections {
  display: grid;
  gap: 0;
}

.landing-section {
  align-items: start;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  display: grid;
  gap: 2rem;
  grid-template-columns: minmax(0, 10rem) minmax(0, 1fr);
  min-height: 70vh;
  padding: 5rem 2rem;
}

.landing-section__body {
  max-width: 54rem;
}

.landing-section__title {
  font-size: clamp(3rem, 11vw, 7rem);
  font-weight: 900;
  letter-spacing: -0.06em;
  line-height: 0.9;
  margin: 0 0 1.5rem;
  text-transform: uppercase;
}

.landing-section__title span {
  display: block;
}

.landing-section--blue .landing-section__title {
  color: #f8fafc;
}

.landing-section--cyan .landing-section__title {
  color: #67e8f9;
}

.landing-section--indigo .landing-section__title {
  color: #818cf8;
}

@media (max-width: 960px) {
  .landing-hero {
    grid-template-columns: minmax(0, 1fr);
    padding-inline: 1.25rem;
    padding-top: 7rem;
  }

  .landing-video-frame {
    aspect-ratio: 16 / 10;
  }

  .landing-bridge,
  .landing-section {
    grid-template-columns: minmax(0, 1fr);
    padding-inline: 1.25rem;
  }
}

@media (max-width: 640px) {
  .landing-title {
    font-size: min(31vw, 8rem);
  }

  .landing-kicker,
  .landing-status,
  .landing-bridge__label,
  .landing-section__index {
    font-size: 0.64rem;
    letter-spacing: 0.28em;
  }

  .landing-lede,
  .landing-bridge__copy,
  .landing-section__copy {
    font-size: 0.96rem;
    line-height: 1.7;
  }
}
